import { forwardRef, type Ref, type SVGProps } from "react";

function SvgStopWatch(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 8.333 5.667 6m.666-5h3.334M14 8.333a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgStopWatch);
export default ForwardRef;
